export type ParkingProductModel = {
  id?: number;
  pmcId?: number;
  pmcName: string;
  location: string;
  countryCode?: string;
  placeId?: number;
  totalParkingRights?: number;
  totalDelegatedParkingRights?: number;
  totalAssignedParkingRights?: number
  totalPedestrianRights: number;
  totalDelegatedPedestrianRights: number;
  hasUnlimitedEntryRights: boolean;
  hasFutureCapacities?: boolean;
  contractStartDate?: Date;
  productType: ParkingProductType;
  contractType: ContractType;
  seasonTicketReferenceId: string;
  firstAvailableContractStartDate?: Date;
  expirationDate?: Date;
};

export enum ParkingProductType  {
  ParkingRights = 1,
  PedestrianAccess = 2,
}

export enum ContractType  {
  SeasonTicket = 1,
  GoBusiness = 2,
}

export type LocatedParkingProductModel = {
  id?: number;
  pmcId?: number;
  pmcName: string;
  location: string;
  countryCode?: string;
  placeId?: number;
  contractStartDate?: Date;
  contractType: ContractType;
  productType: ParkingProductType
}

export type ResendDelegeeInviteRequest = {
  seasonTicketOwnerCrmId: string;
  registrationId: string;
  email: string;
  entryRightId: string;
};
